var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframe",staticClass:"form-container",attrs:{"sandbox":"allow-forms allow-scripts allow-modals allow-popups allow-same-origin allow-top-navigation","src":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }